import classNames from 'classnames';

import Icon from 'components/Icon/Icon';
import { useNotifications } from 'store';

import styles from './Notifications.module.scss';

const Notifications = () => {
  const [{ remove }, items] = useNotifications();

  return (
    <div className={styles.wrapper}>
      {items.map(({ id, text, type = 'info' }) => (
        <div key={id} className={classNames(styles.notification, styles[type])}>
          <div className={styles.text}>{text}</div>
          <button
            type="button"
            className={styles['close-button']}
            onClick={() => remove(id)}
          >
            <Icon name="close-circle" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default Notifications;
